module.exports = __webpack_public_path__ + "img/unknown_cr.28d78d58.png";